import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { ScrollbarProps } from "./Scrollbar.types";

const Scrollbar = forwardRef<HTMLDivElement, PropsWithChildren<ScrollbarProps>>(
  (
    { size = "small", children, className, ...ScrollbarProps },
    forwardedRef,
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={cn(
          `max-h-[200px] overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-[30px] [&::-webkit-scrollbar-thumb]:bg-primary dark:[&::-webkit-scrollbar-thumb]:bg-primary [&::-webkit-scrollbar-track]:rounded-[30px] [&::-webkit-scrollbar-track]:bg-neutral-100 dark:[&::-webkit-scrollbar-track]:bg-neutral-100`,
          {
            "[&::-webkit-scrollbar]:w-2": size === "small",
            "[&::-webkit-scrollbar]:w-2.5": size === "medium",
          },
          className,
        )}
        {...ScrollbarProps}
      >
        {children}
      </div>
    );
  },
);

Scrollbar.displayName = "Scrollbar";

export default Scrollbar;
